/**
 * @generated SignedSource<<66a33103d537bb30b1f74beb85ba0946>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "BankIdForm_CollectBankIdAuthRefetchQuery",
            "selections": [
                {
                    "args": (v1 /*: any*/),
                    "kind": "FragmentSpread",
                    "name": "BankIdForm_CollectBankIdAuth"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "BankIdForm_CollectBankIdAuthRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CollectBankIdAuthPayload",
                    "kind": "LinkedField",
                    "name": "collectBankIdAuth",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "qrData",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "84162c7aa2600c4f594af690f7ff185d",
            "id": null,
            "metadata": {},
            "name": "BankIdForm_CollectBankIdAuthRefetchQuery",
            "operationKind": "query",
            "text": "query BankIdForm_CollectBankIdAuthRefetchQuery(\n  $model: CollectBankIdAuthInput!\n) {\n  ...BankIdForm_CollectBankIdAuth_47b4ea\n}\n\nfragment BankIdForm_CollectBankIdAuth_47b4ea on Query {\n  collectBankIdAuth(model: $model) {\n    message\n    status\n    qrData\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "219cc11e81537d40e8f4b3a690127d9f";
export default node;
